import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { menuItems } from '../header/menu'; // import menuItems

const BreadCrumbs = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    // Recursive function to find the path in menuItems
    const findBreadcrumbPath = (items, path, parentPath = []) => {
        for (let item of items) {
            const newPath = [...parentPath, item];

            // Exact match for current route
            if (item.to === path) return newPath;

            // Recurse into children
            if (item.children) {
                const childPath = findBreadcrumbPath(item.children, path, newPath);
                if (childPath) return childPath;
            }
        }
        return null;
    };

    const breadcrumbItems = findBreadcrumbPath(menuItems, currentPath) || [];

    return (
        <section className='bg-gray-200 w-full py-2 h-[70px]'>
            <div className='text-sm flex items-center gap-2 py-3 place-content-center'>
                {/* Always start with Home */}
                <Link to="/" className="hover:text-green-600 font-semibold">Home</Link>

                {breadcrumbItems.map((item, idx) => {
                    // Skip "Home" to avoid duplication
                    if (item.label === "Home") return null;

                    // Skip external links
                    if (item.external) return null;

                    return (
                        <React.Fragment key={idx}>
                            <MdKeyboardDoubleArrowRight className='text-green-600' />
                            {item.to ? (
                                <Link to={item.to} className="hover:text-green-600 font-semibold">
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="font-semibold">{item.label}</span>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </section>
    );
};

export default BreadCrumbs;
